import React from 'react';
const tomes = [{
  emoji: '🔵',
  title: 'Tomo 1 — El Despertar Sensorial (0-6m)',
  desc: '24 sesiones · Neurodesarrollo, masajes, contraste visual y regulación'
}, {
  emoji: '🟢',
  title: 'Tomo 2 — Conquista del Espacio (6-12m)',
  desc: '24 sesiones · Gateo, sedestación, permanencia del objeto y pinza'
}, {
  emoji: '🟠',
  title: 'Tomo 3 — Los Primeros Pasos (12-18m)',
  desc: '24 sesiones · Marcha, explosión del lenguaje y regulación emocional'
}, {
  emoji: '🟣',
  title: 'Tomo 4 — El Mundo de las Palabras (18-24m)',
  desc: '24 sesiones · Vocabulario, combinaciones, juego simbólico y esfínteres'
}, {
  emoji: '🟡',
  title: 'Tomo 5 — Pequeños Exploradores (24-30m)',
  desc: '24 sesiones · Pre-escritura, narrativa, funciones ejecutivas y jardín'
}, {
  emoji: '⭐',
  title: 'Tomo 6 — El Salto Cognitivo (30-36m)',
  desc: '24 sesiones · Pre-lectura, pre-matemática, grafomotricidad y cierre SAP'
}];
const includes = ['Marco teórico de neurodesarrollo por etapa', '24 sesiones con objetivo, actividad, evidencia y cierre', 'Semáforo de alertas (verde/amarillo/rojo) por mes', 'Fichas imprimibles listas para sesión', 'Checklists de seguimiento SAP por mes', 'Guiones para explicar a familias (técnico + simple)', 'Protocolos de derivación interdisciplinaria', '100% adaptado a la realidad clínica argentina'];
export function WhatYouGet() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: 'rgb(248, 250, 252)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-305">
      <div className="mx-auto max-w-4xl" data-id="element-306">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center leading-10 text-gray-900 m-0 mb-8" data-id="element-307">
          Lo que <span className="text-cyan-brand" data-id="element-308">recibís</span>
        </h2>

        {/* 6 Tomos Card */}
        <div className="mx-auto max-w-3xl mb-8" data-id="element-309">
          <div className="bg-white border border-cyan-brand/30 rounded-xl p-5 shadow-sm" data-id="element-310">
            <h3 className="text-lg font-black text-cyan-brand m-0 mb-1" data-id="element-311">
              👶 LOS 6 TOMOS
            </h3>
            <p className="text-xs text-gray-500 m-0 mb-4" data-id="element-312">
              Para profesionales de estimulación temprana de 0 a 36 meses
            </p>

            <div className="space-y-3" data-id="element-313">
              {tomes.map(tome => <div key={tome.title} className="flex items-center gap-2 text-gray-900" data-id="element-314">
                  <span className="text-lg" data-id="element-315">{tome.emoji}</span>
                  <div className="flex-1 text-sm" data-id="element-316">
                    <span className="font-bold" data-id="element-317">{tome.title}</span>{' '}
                    <span className="text-gray-500" data-id="element-318">{tome.desc}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Each Tome Includes */}
        <div className="mx-auto max-w-3xl bg-cyan-brand/5 text-center border border-cyan-brand/30 rounded-xl p-6 shadow-sm" data-id="element-319">
          <h3 className="text-lg font-black text-cyan-brand m-0 mb-4" data-id="element-320">
            Cada tomo incluye:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-321">
            {includes.map(item => <div key={item} className="flex items-start gap-2 text-left" data-id="element-322">
                <span className="shrink-0 font-bold text-cyan-brand text-sm" data-id="element-323">
                  ✅
                </span>
                <span className="text-xs text-gray-900" data-id="element-324">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}